import { createFileRoute } from "@tanstack/react-router";
import { mcpProtectedResourceMetadataRoute } from "@/app-clients/chatgpt-dog-search";

export const Route = createFileRoute(
    "/.well-known/oauth-protected-resource/api/mcp",
)({
    ...mcpProtectedResourceMetadataRoute,
});
